import farm from './farm.svg';

export default function FarmIcon() {
  return <img src={farm} alt={'farm'} width="32" height="32" />;
}
